import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import Policy from 'modules/payroll_bundle/store/models/Policy'

export class Policies extends Collection<Policy> {
  get cacheKey(): string {
    return 'policies'
  }

  model() {
    return Policy
  }

  get not_archived(): Policy[] {
    return this.models.filter((p) => p.attributes.archived_at === null)
  }
}

const singleton: Policies = new Policies()

export default singleton

const { provider: PoliciesProvider, hook: usePolicies } = createCollectionContext<
  Policy,
  Policies
>()

export { PoliciesProvider, usePolicies }
